import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { CheckboxModule } from 'primeng/checkbox';

import { TranslateModule } from '@ngx-translate/core';

import { Selector } from './selector.component';

@NgModule({
  imports: [
    ButtonModule,
    CheckboxModule,
    CommonModule,
    FormsModule,
    InputTextModule,
    ListboxModule,
    MenuModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  declarations: [
    Selector
  ],
  providers: [],
  exports: [Selector]
})
export class SelectorModule { }
